import React, { Component } from "react";
import PromoImageCard from "../../components/shared/PromoImageCard";
import { connect } from "react-redux";
import styles from "../../assets/css/modules/health-store/health-store.css";
import Store from "./../../content/Store";
import { Paths, Urls } from "../../constants/UrlConstants";
// import { Layouts } from "../../constants/Constants";


export const mapStateToProps = (state) => {
  const layout= state.layoutReducer && state.layoutReducer.layout ;
  const currentPolicy = state.policyReducer.selectedPolicy;
  return {
    layout:layout,
    isSMEModular: currentPolicy && currentPolicy.IsSMEModular,
    isLargeCorporate: currentPolicy && currentPolicy.IsLargeCorporate,
    isEDCA: currentPolicy && currentPolicy.IsEDCA,
    isIndividual :currentPolicy && currentPolicy.IsIndividual,
  };
};

export class MskSection extends Component {
  constructor(props) {
    super(props);
    console.log(props);
  }
  render() {
    return (
        <div
            id="puregymPromo"
            className={"col-sm-12 " + styles.puregymPromo}
        >
            <PromoImageCard
                ImgSrc={Store.GPAppointments247.PhysioSection.IconSrc}
                ImgSrcMobile={Store.GPAppointments247.PhysioSection.IconSrcMobile}
                Heading={Store.GPAppointments247.PhysioSection.Heading}
                Description={Store.GPAppointments247.PhysioSection.Description}
                LinkText={Store.GPAppointments247.PhysioSection.LinkText}
                LinkTo={this.props.accessPage  === Paths.GPAppointments247 ? 
                  Paths.WorkingBody:
                  // this.props.layout ===Layouts.MOL?
                  // this.props.IsIndividual ? 
                  // Store.GPAppointments247.PhysioSection.LinkTo : 
                  // this.props.IsSMEModular ? Urls.GpSME: this.props.IsLargeCorporate ? 
                  // Urls.GpLarge :Store.GPAppointments247.PhysioSection.LinkTo :
                  // Store.GPAppointments247.PhysioSection.LinkTo : 
                  this.props.accessPage === Urls.WorkingBody ? 
                  Store.GPAppointments247.PhysioSection.LinkMSKTo : 
                  Paths.WorkingBody 
                   }
                // IsExternalLink={this.props.accessPage  === Paths.GPAppointments247 || this.props.accessPage === Urls.MSKBannerUrl ? true:false}
                IsExternalLink={this.props.accessPage === Urls.MSKBannerUrl ? true:false}
                LeftImage={true}
                IsNuffieldGym={Store.GPAppointments247.PhysioSection.IsNuffieldGym}
                UniqueKey = {this.props.UniqueKey}
                Layout={this.props.layout}
                accessPage={this.props.accessPage}
            />
        </div> 
    );
  }
}


export default connect(
  mapStateToProps
)(MskSection);